import { OrgUserWithRole, UserOrg, UserRole } from '../types/User';
import { api } from './api';

const API_URL = process.env.REACT_APP_API_URL;

export const getIsExec = async (): Promise<any> => {
  return await api.get(`${API_URL}/users/is_exec`);
};

export const getUsersForOrg = async (
  orgId: number,
  {
    limit,
    offset,
  }: {
    limit: number;
    offset: number;
  }
): Promise<{ data: OrgUserWithRole[]; total: number }> => {
  return await api.get(
    `${API_URL}/users/orgs/${orgId}?limit=${limit}&offset=${offset}`,
    'Failed to get users for organization'
  );
};

export const searchUsersForOrg = async (
  orgId: number,
  {
    searchQuery,
    limit,
    offset,
  }: {
    searchQuery: string;
    limit: number;
    offset: number;
  }
): Promise<{ data: OrgUserWithRole[]; total: number }> => {
  return await api.get(
    `${API_URL}/users/orgs/${orgId}/search?name=${encodeURIComponent(searchQuery)}&limit=${limit}&offset=${offset}`,
    'Failed to search users for organization'
  );
};

export const getUserOrg = async (orgId: number): Promise<UserOrg> => {
  return await api.get(`${API_URL}/users/org/${orgId}`);
};

export const addUserToOrg = async (
  orgId: number,
  user: {
    username: string;
    role: UserRole;
    shouldSendEmail: boolean;
  }
): Promise<OrgUserWithRole> => {
  return await api.post(
    `${API_URL}/users/orgs/${orgId}`,
    user,
    'Failed to add user to organization'
  );
};

export const addUsersToOrgCSV = async (
  orgId: number,
  file: File,
  addedBy: string
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('addedBy', addedBy);
  return await api.post(
    `${API_URL}/users/orgs/${orgId}/bulk`,
    formData,
    'Failed to bulk add users to organization',
    true
  );
};

export const updateUserRole = async (
  orgId: number,
  userId: number,
  role: UserRole
): Promise<OrgUserWithRole> => {
  return await api.put(
    `${API_URL}/users/${userId}/orgs/${orgId}/role`,
    { role },
    'Failed to update user role'
  );
};
